"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Box = _interopRequireDefault(require("../Containers/Box"));
var _ButtonWithLoader = _interopRequireDefault(require("../Buttons/ButtonWithLoader"));
var _ErrorSvg = _interopRequireDefault(require("./ErrorSvg"));
var _Text = _interopRequireDefault(require("../Typography/Text"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var propTypes = {
  error: _propTypes["default"].object,
  resetErrorBoundary: _propTypes["default"].func,
  displayInfo: _propTypes["default"].object,
  DebugErrorComponent: _propTypes["default"].func,
  debugErrorComponentProps: _propTypes["default"].object
};
var ErrorFallbackCommon = function ErrorFallbackCommon(_ref) {
  var error = _ref.error,
    resetErrorBoundary = _ref.resetErrorBoundary,
    _ref$displayInfo = _ref.displayInfo,
    text = _ref$displayInfo.text,
    buttonText = _ref$displayInfo.buttonText,
    hint = _ref$displayInfo.hint,
    DebugErrorComponent = _ref.DebugErrorComponent,
    debugErrorComponentProps = _ref.debugErrorComponentProps;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    retrying = _useState2[0],
    setRetrying = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    d: "flex",
    center: true,
    direction: "column",
    h: "100%"
  }, /*#__PURE__*/_react["default"].createElement(_ErrorSvg["default"], null), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: "textSecondary",
    fontSize: "large",
    mV: "base"
  }, text || "Something went wrong..."), hint && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: "textTertiary",
    mB: "base"
  }, hint), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    d: "flex",
    direction: "row",
    alignItem: "center",
    justifyContent: "center",
    gap: "base",
    w: "100%"
  }, DebugErrorComponent && /*#__PURE__*/_react["default"].createElement(DebugErrorComponent, _extends({
    stackError: error.stack,
    errorMessage: error.message
  }, debugErrorComponentProps)), /*#__PURE__*/_react["default"].createElement(_ButtonWithLoader["default"], {
    onClick: function onClick() {
      setRetrying(true);
      setTimeout(function () {
        resetErrorBoundary({
          error: error
        });
      }, 1000);
    },
    showLoader: retrying,
    loadingText: buttonText || "Retrying..."
  }, buttonText || "Try again")));
};
ErrorFallbackCommon.propTypes = propTypes;
ErrorFallbackCommon.displayName = "Error_Fallback_Common";
var _default = ErrorFallbackCommon;
exports["default"] = _default;